module.exports = __webpack_public_path__ + "static/4_2_recommendation_HR-aad91a00a5c103a8240c646785ee45ae.svg";